import { Component, Input, OnInit } from '@angular/core';
import { ModalService } from '../../services/modal.service';
import {
  FormControl,
  FormGroup,
  Validators,
  FormBuilder,
} from '@angular/forms';
import { SettingsService } from '../../../core/http/settings.service';
import { ObsService } from '../../../core/http/obs.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import * as _moment from 'moment';
import { SampleService } from 'src/app/core/http/sample.service';
const moment = _moment;

@Component({
  selector: 'app-ft-single',
  templateUrl: './ft-single.component.html',
  styleUrls: ['./ft-single.component.scss'],
})
export class FtSingleComponent implements OnInit {
  @Input() Patient_type;
  @Input() gender;
  @Input() AmnioticFluid;
  @Input() CervicalOs;
  @Input() Chorionicity;
  @Input() Amnionicity;
  @Input() Grade;
  @Input() PlacentaLocation;
  @Input() PlacentaLocationAnatomic;
  @Input() Presentation;
  @Input() FetalAnomaly;
  @Input() NoofFetus;
  @Input() TechnicalConditions;
  @Input() FetalHeartBeat;
  @Input() image1;
  @Input() image2;
  @Input() disable;

  repeat = false;
  trimister = false;
  copy = false;
  isLoading = false;
  response: any = [];
  result_id;
  Errors = null;
  form: FormGroup;
  patient;
  FetchPatient;
  drs: any = [];
  firstPic;
  fullImage;
  result: any = [];
  disabled: boolean = true;
  suggestion3 = false;
  suggestion1 = false;
  suggestion2 = false;

  userdrId;
  valueE;
  resultSaved = false;
  finalizeLoading = false;
  comment: any;
  otherData;
  initializerId;
  dr = '';
  initialdr = '';
  otherdrs;

  con() {
    console.log(this.form.value);
  }

  constructor(
    private modal: ModalService,
    private _snackBar: MatSnackBar,
    public auth: SettingsService,
    private obs: ObsService,
    private fb: FormBuilder,
    public setting: SettingsService,
    private sample: SampleService
  ) {}

  ngOnInit(): void {
    this.patient = this.obs._patient;
    this.obs.getPatient(this.obs._patient.patient_id).subscribe(
      (resSuccess) => {
        this.FetchPatient = resSuccess[0];
        this.form.patchValue({
          result_id: this.patient.result_id,
          single: {
            patient_id: this.patient.patient_id,
            referance_id: this.FetchPatient.ref_doct_code,
            branch_code: this.FetchPatient.Branch_Code,
            sex: this.FetchPatient.sex,
            author_id: this.FetchPatient.Author_id,
          },
        });
        this.fetchResult();
        console.log(this.form.value);
        console.log(this.FetchPatient);
        console.log(this.Patient_type);
      },
      (resErr) => {}
    );

    this.obs.getDrs().subscribe(
      (resSuccess) => {
        this.drs = resSuccess;
      },
      (resErr) => {}
    );

    this.sample.getDrs().subscribe(
      (resSuccess: any) => {
        this.otherdrs = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);
      },
      (resErr) => {
        this.isLoading = false;
        this.Errors = resErr;
      }
    );

    this.form = this.fb.group({
      result_id: [0],
      single: this.fb.group({
        ftsingle_id: [0],
        patient_id: [''],
        referance_id: [''],
        author_id: [''],
        branch_code: [''],
        sex: [''],
        lmp: [''],
        ga: [''],
        edd: [''],
        no_of_fetus: [''],
        tech_condition: [''],
        fetal_heart_beat: [''],
        mean_gsd: [''],
        crl: [''],
        nt_thikness: [''],
        amniotic_fluid: [''],
        p_location: [''],
        us_average: [''],
        uss_edd: [''],
        gender: [''],
        right_adnexium: [''],
        left_adnexium: [''],
        cervical_os: [''],
        bpd: [''],
        fl: [''],
        ac: [''],
        hc: [''],
        efw: [''],
        other_finding: [''],
        comments: [''],
        suggestion1: [false],
        suggestion2: [false],
        suggestion3: [false],
        ftimage: [''],
        fin_year: [''],
        entry_date: [''],
        update_entry_date: [''],
        doctor_id: [''],
      }),
    });
  }

  fetchResult() {
    this.obs.getFTSingle(this.patient.result_id).subscribe(
      (resSuccess) => {
        this.result = resSuccess;
        console.log(resSuccess);
        this.form.patchValue({
          single: {
            ftsingle_id: this.result.single.ftsingle_id,
            lmp: this.result.single.lmp,
            ga: this.result.single.ga,
            edd: this.result.single.edd,
            no_of_fetus: this.result.single.no_of_fetus,
            tech_condition: this.result.single.tech_condition,
            fetal_heart_beat: this.result.single.fetal_heart_beat,
            mean_gsd: this.result.single.mean_gsd,
            crl: this.result.single.crl,
            nt_thikness: this.result.single.nt_thikness,
            amniotic_fluid: this.result.single.amniotic_fluid,
            p_location: this.result.single.p_location,
            us_average: this.result.single.us_average,
            uss_edd: this.result.single.uss_edd,
            gender: this.result.single.gender,
            right_adnexium: this.result.single.right_adnexium,
            left_adnexium: this.result.single.left_adnexium,
            cervical_os: this.result.single.cervical_os,
            bpd: this.result.single.bpd,
            fl: this.result.single.fl,
            ac: this.result.single.ac,
            hc: this.result.single.hc,
            efw: this.result.single.efw,
            other_finding: this.result.single.other_finding,
            comments: this.result.single.comments,
            suggestion1: JSON.parse(this.result.single.suggestion1),
            suggestion2: JSON.parse(this.result.single.suggestion2),
            suggestion3: JSON.parse(this.result.single.suggestion3),
            ftimage: this.result.single.ftimage,
            fin_year: this.result.single.fin_year,
            entry_date: this.result.single.entry_date,
            update_entry_date: this.result.single.update_entry_date,
            doctor_id: this.result.single.doctor_id,
          },
        });
        this.suggestion3 = JSON.parse(this.result.single.suggestion3);
        this.suggestion1 = JSON.parse(this.result.single.suggestion1);
        this.suggestion2 = JSON.parse(this.result.single.suggestion2);
        console.log(this.form.value);
        this.obs.getImage(this.result.single.ftimage).subscribe(
          (resSuccess) => {
            this.fullImage = resSuccess;
            console.log(resSuccess);
            console.log(this.result.single.ftimage);
          },
          (resErr) => {}
        );
      },
      (resErr) => {}
    );
  }

  drValue(e) {
    this.valueE = e;
    this.userdrId = e.value;
  }

  initatorValue(e) {
    this.valueE = e;
    this.initializerId = e.value;
  }

  overide() {
    this.setting
      .postOverideFinializer(
        this.result_id,
        this.userdrId,
        this.initializerId,
        this.comment
      )
      .subscribe(
        (resSuccess) => {
          this.otherData = resSuccess;
          this.isLoading = false;

          if (this.otherData.success) {
            this._snackBar.open('Saved Successfully', '', {
              duration: 2000,
              verticalPosition: 'top',
            });
            // window.location.reload();
          } else {
            this.Errors = 'Not successful, please try again';
            console.log('error');
          }
        },
        (resErr) => {
          this.isLoading = false;
          this.Errors = resErr;
          console.log(resErr);
        }
      );
  }

  getProp(prop) {
    return this[prop];
  }
  setProp(prop, value) {
    this[prop] = value;
  }

  DateChange(event: any) {
    this.form.patchValue({
      single: {
        entry_date: moment(event.target.value).format('YYYY-MM-DD'),
      },
    });
    console.log(this.form.value);
  }
  slectOnChange1(event) {
    this.firstPic = event.value;
    this.disabled = false;
  }
  slectOnChange(event) {
    let fullPic = this.firstPic + '/' + event.value + '.jpg';
    this.form.patchValue({
      single: {
        ftimage: fullPic,
      },
    });
    this.obs.getImage(fullPic).subscribe(
      (resSuccess) => {
        this.fullImage = resSuccess;
        console.log(resSuccess);
        console.log(fullPic);
      },
      (resErr) => {}
    );
    console.log(this.form.value);
  }

  onSubmit(e) {
    // e.preventDefault();
    this.isLoading = true;
    this.form.patchValue({
      single: {
        suggestion1: this.suggestion1 ? this.suggestion1.toString() : 'false',
        suggestion2: this.suggestion2 ? this.suggestion2.toString() : 'false',
        suggestion3: this.suggestion3 ? this.suggestion3.toString() : 'false',
      },
    });
    const { result_id, single } = this.form.value;
    console.log(single);

    this.obs.postFTSinge(result_id, single).subscribe(
      (resSuccess: []) => {
        this.response = resSuccess;
        this.isLoading = false;
        console.log(resSuccess);

        if (this.response.success) {
          this.form.reset();
          this.isLoading = false;
          this._snackBar.open('Saved Successfully', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
        } else {
          this.isLoading = false;
          this._snackBar.open('Error: Please try again', '', {
            duration: 2000,
            verticalPosition: 'top',
          });
          console.log(resSuccess);
        }
      },
      (resErr) => {
        this.isLoading = false;
        this._snackBar.open(resErr, '', {
          duration: 2000,
          verticalPosition: 'top',
        });
        console.log(resErr);
      }
    );
  }
}
